export const initKendo = (kendo, pageContext, DecimalFormatter) => {
  const dtFormat = pageContext.CultureDateTimeFormat;
  const am = dtFormat.AMDesignator || 'AM';
  const pm = dtFormat.PMDesignator || 'PM';

  const groupChar = DecimalFormatter && DecimalFormatter.groupChar ? DecimalFormatter.groupChar : ',';
  const decimalChar = DecimalFormatter && DecimalFormatter.decimalChar ? DecimalFormatter.decimalChar : '.';
  const groupSize = DecimalFormatter && DecimalFormatter.groupSize ? parseInt(DecimalFormatter.groupSize, 10) : 3;
  const numberOfDigits = DecimalFormatter && DecimalFormatter.numberOfDigits ?
    parseInt(DecimalFormatter.numberOfDigits, 10) : 2;
  const currency = pageContext.AccountCurrencyCode ? pageContext.AccountCurrencyCode : 'USD';

  // Initialize cultures object if it doesn't exist (needed for test environment)
  // eslint-disable-next-line no-param-reassign
  if (!kendo.cultures) {
    // eslint-disable-next-line no-param-reassign
    kendo.cultures = {};
  }

  // eslint-disable-next-line no-param-reassign
  kendo.cultures[pageContext.Culture] = {
    name: pageContext.CultureName,
    numberFormat: {
      pattern: ['-n'], // numberFormat has only negative pattern unline the percent and currency, negative pattern: one of (n)|-n|- n|n-|n -
      decimals: numberOfDigits, // number of decimal places
      ',': groupChar, // string that separates the number groups (1,000,000)
      '.': decimalChar, // string that separates a number from the fractional point
      groupSize: [groupSize], // the length of each number group
      percent: { // formatting rules for percent number
        pattern: ['-n %', 'n %'], // [negative pattern, positive pattern]; negativePattern: one of -n %|-n%|-%n|%-n|%n-|n-%|n%-|-% n|n %-|% n-|% -n|n- %;positivePattern: one of n %|n%|%n|% n
        decimals: numberOfDigits, // number of decimal places
        ',': groupChar, // string that separates the number groups (1,000,000 %)
        '.': decimalChar, // string that separates a number from the fractional point
        groupSize: [groupSize], // the length of each number group
        symbol: '%', // percent symbol
      },
      currency: {
        pattern: [`(${currency} n)`, `${currency} n`], // [negative pattern, positive pattern];negativePattern: one of "($n)|-$n|$-n|$n-|(n$)|-n$|n-$|n$-|-n $|-$ n|n $-|$ n-|$ -n|n- $|($ n)|(n $)";positivePattern: one of "$n|n$|$ n|n $"
        decimals: numberOfDigits, // number of decimal places
        ',': groupChar, //  string that separates the number groups (1,000,000 $)
        '.': decimalChar, //  string that separates a number from the fractional point
        groupSize: [groupSize], //  the length of each number group
        symbol: currency, //  currency symbol
      },
    },
    calendars: {
      standard: {
        days: {
          names: pageContext.CultureDayNames, // full day names
          namesAbbr: pageContext.CultureDayNamesShort, // abbreviated day names
          namesShort: pageContext.CultureDayNamesMin, // shortest day names
        },
        months: {
          names: pageContext.CultureMonthNames, // full month names
          namesAbbr: pageContext.CultureMonthNamesShort, // abbreviated month names
        },
        AM: [am, am.toLowerCase(), am.toUpperCase()], // ["AM", "am", "AM"], // AM and PM designators
        PM: [pm, pm.toLowerCase(), pm.toUpperCase()], // ["PM", "pm", "PM"],  // [standard,lowercase,uppercase]
        patterns: { // set of predefined date and time patterns used by the culture.
          d: dtFormat.ShortDatePattern,
          D: dtFormat.LongDatePattern,
          F: dtFormat.FullDateTimePattern,
          g: `${dtFormat.ShortDatePattern} ${dtFormat.ShortTimePattern}`,
          G: `${dtFormat.ShortDatePattern} ${dtFormat.LongTimePattern}`,
          m: dtFormat.MonthDayPattern,
          M: dtFormat.MonthDayPattern,
          s: dtFormat.SortableDateTimePattern,
          t: dtFormat.ShortTimePattern,
          T: dtFormat.LongTimePattern,
          u: dtFormat.UniversalSortableDateTimePattern,
          y: dtFormat.YearMonthPattern,
          Y: dtFormat.YearMonthPattern,
        },
        firstDay: pageContext.CultureFirstDay, // the first day of the week (0 = Sunday, 1 = Monday, etc)
      },
    },
  };

  // Set the culture if the culture method exists (may not exist in test environments)
  if (typeof kendo.culture === 'function') {
    kendo.culture(pageContext.Culture);
  }
};
